import React from 'react'

import * as S from './styles'

/**
 * @typedef {Object} GridProps
 * @property {React.ReactNode | React.ReactNode[]} children
 * @property {boolean} [grow=false]
 * @property {number[]} [colSize=[12]]
 * @property {string | number} [gap]
 * @property {boolean} [responsive=false]
 * @property {number} [xs=12]
 * @property {number} [sm=6]
 */

/**
 * @param {GridProps} props
 */
export default function Grid({
  children,
  grow = false,
  colSize = [12],
  gap,
  responsive = false,
  xs = 12,
  sm = 6
}) {
  if (!Array.isArray(children)) children = [children]

  return (
    <>
      <S.Grid gap={gap} grow={grow}>
        {children &&
          children.map((child, index) => (
            <S.Grid.Col
              // eslint-disable-next-line react/no-array-index-key
              key={`grid-${index}`}
              style={{ minWidth: '42px' }}
              {...(responsive
                ? { xs, sm, md: colSize[index] }
                : { span: colSize[index] })}
            >
              {child}
            </S.Grid.Col>
          ))}
      </S.Grid>
    </>
  )
}
